import { Bet } from "interfaces/bet";
import ShareButtons from "components/bet-details-page/share-buttons";
import { Link } from "react-router-dom";
import BlockyMediumText from "components/custom-texts/blocky-medium-text";
import { useAppSelector } from "state/hooks";
import { getGroupStyles } from "state/slices/group-slice";
import { ContestEntryState } from "utils/contest-utils";

interface Props {
  bet: Bet;
  contestEntryState?: ContestEntryState;
}

const SecondaryColorHeavierBlock = ({ children }: { children: React.ReactNode }) => {
  const secondaryColor = useAppSelector(getGroupStyles).secondary_color;
  return (
    <span style={{ color: secondaryColor, fontSize: "1.2em" }}>
    {children}
  </span>
  );
};

interface MessageTextProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const MessageText = ({ children, style }: MessageTextProps) => (
  <BlockyMediumText style={{ color: "white", ...style }}>
    {children}
  </BlockyMediumText>
);

const Content = ({ bet, contestEntryState }: Props) => {
  const isEntryValid = contestEntryState?.isValid;
  const isOptionalPick = contestEntryState?.isValid &&
    contestEntryState.totalNumberOfPicks > contestEntryState.minimalNumberOfUniqueContestantsForEntryToBeValid;

  return (
    <div data-testid={"successful-bet-modal-content"}>
      {contestEntryState && !isOptionalPick && (
        <div style={{ marginBottom: "20px", textAlign: "center" }}>
          {isEntryValid ? (
            <>
              <MessageText>
                You've made at
                least <SecondaryColorHeavierBlock>{contestEntryState.minimalNumberOfUniqueContestantsForEntryToBeValid} picks</SecondaryColorHeavierBlock> and
                your entry
                is <SecondaryColorHeavierBlock>valid</SecondaryColorHeavierBlock>.
              </MessageText>
              <MessageText style={{ marginTop: "10px" }}>
                If you have remaining balance, you may make more picks during the contest
              </MessageText>
            </>
          ) : (
            <>
              <MessageText>
                You've
                made <SecondaryColorHeavierBlock>{contestEntryState.numberOfPicksOnDistinctContestants} of {contestEntryState.minimalNumberOfUniqueContestantsForEntryToBeValid} picks</SecondaryColorHeavierBlock> in
                this contest
              </MessageText>
              <MessageText style={{ marginTop: "10px" }}>
                Make at
                least <SecondaryColorHeavierBlock>{contestEntryState.remainingNumberOfPicksOnDistinctContestantsForEntryToBeValid} more</SecondaryColorHeavierBlock> {contestEntryState.remainingNumberOfPicksOnDistinctContestantsForEntryToBeValid > 1 ? "picks" : "pick"} with
                different contestants to complete your entry!
              </MessageText>
            </>
          )}
        </div>
      )}
      <BlockyMediumText
        style={{ color: "white", display: "flex", justifyContent: "center" }}
      >
        Click&nbsp;<Link to={`/bets/${bet.id}`}>here</Link>&nbsp;to view details
        about your pick.
      </BlockyMediumText>
      {(!contestEntryState || isEntryValid) && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
          <ShareButtons bet={bet} />
        </div>
      )}
    </div>
  );
};

export default Content;
